import { css } from "@emotion/css";
import { Box, Typography } from "@mui/material";
import { LandingPageSection } from "../../components/static-page-components/landing-page-section";

function ContactSupport() {
  return (
    <LandingPageSection>
      <div
        className={css`
        display: "flex",
        flexDirection: "column",
        position: "relative",
        flexShrink: "0",
        boxSizing: "border-box",
        marginTop: "108px",
        width: "100%",
        maxWidth: "1216px",
        "@media (max-width: 640px)": {
          paddingLeft: "32px",
          paddingRight: "32px",
        },
      `}
      >
        <Box
          sx={{
            gap: "20px",
            display: "flex",
            "@media (max-width: 991px)": {
              flexDirection: "column",
              alignItems: "stretch",
              gap: "0px",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
              lineHeight: "normal",
              width: "50%",
              marginLeft: "0px",
              p: 1,
              "@media (max-width: 991px)": {
                width: "100%",
                marginLeft: 0,
              },
            }}
          >
            <Box
              sx={{
                color: "#111827",
                fontFamily: "Jost, sans-serif",
                lineHeight: "1",
                textTransform: "capitalize",
                "@media (max-width: 991px)": {
                  maxWidth: "100%",
                  fontSize: "40px",
                },
              }}
            >
              <Typography variant="h4" component="h2" className="font-size-5">
                Contact Support
              </Typography>
            </Box>
            <Typography variant="body2" className="font-size-4 contain-text">
              Whether you're interested in our referral program or a custom
              soltuion, we're here to help you find the right plan to support
              your need. Tell us about you and we'll be in touch.
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
              lineHeight: "normal",
              width: "50%",
              marginLeft: "20px",
              minHeight: 900,
              "@media (max-width: 991px)": {
                width: "100%",
                marginLeft: 0,
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                position: "relative",
                flexShrink: "0",
                boxSizing: "border-box",
                marginTop: "20px",
                minHeight: 900,
              }}
            >
              <iframe
                src="https://api.leadconnectorhq.com/widget/form/tAuIu7FvQ2oZSigmg5c9"
                style={{
                  width: "100%",
                  height: "100%",
                  minHeight: 900,
                  border: "none",
                  borderRadius: "16px",
                }}
                id="inline-tAuIu7FvQ2oZSigmg5c9"
                data-layout="{'id':'INLINE'}"
                data-trigger-type="alwaysShow"
                data-trigger-value=""
                data-activation-type="alwaysActivated"
                data-activation-value=""
                data-deactivation-type="neverDeactivate"
                data-deactivation-value=""
                data-form-name="HDG-General-Contact-Form"
                data-height="905"
                data-layout-iframe-id="inline-tAuIu7FvQ2oZSigmg5c9"
                data-form-id="tAuIu7FvQ2oZSigmg5c9"
                title="HDG-General-Contact-Form"
              />
              <script src="https://link.msgsndr.com/js/form_embed.js"></script>
            </Box>
          </Box>
        </Box>
      </div>
    </LandingPageSection>
  );
}

export default ContactSupport;
